import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import OpenQuestionsEmbed from '../components/Exercise/OpenQuestionsEmbed';

export default Node.create({
  name: 'openQuestionsExercise',
  
  group: 'block',
  
  atom: true,
  draggable: true,
  
  addAttributes() {
    return {
      questions: {
        default: [],
        parseHTML: element => {
          const data = element.getAttribute('questions');
          if (data) {
            try {
              return JSON.parse(data);
            } catch (e) {
              console.error('Error parsing OpenQuestions from HTML:', e);
              return [];
            }
          }
          return [];
        },
        renderHTML: attributes => {
          if (attributes.questions) {
            return {
              questions: JSON.stringify(attributes.questions)
            };
          }
          return {};
        }
      },
      referenceText: {
        default: '',
        parseHTML: element => element.getAttribute('referenceText') || '',
        renderHTML: attributes => {
          if (attributes.referenceText) {
            return { referenceText: attributes.referenceText };
          }
          return {};
        }
      },
      title: {
        default: 'Open Questions Exercise',
        parseHTML: element => element.getAttribute('title') || 'Open Questions Exercise',
        renderHTML: attributes => {
          if (attributes.title) {
            return {
              title: attributes.title
            };
          }
          return {};
        }
      },
      level: {
        default: 'B1',
        parseHTML: element => element.getAttribute('level') || 'B1',
        renderHTML: attributes => {
          if (attributes.level) {
            return {
              level: attributes.level
            };
          }
          return {};
        }
      },
      exerciseId: {
        default: null,
        parseHTML: element => element.getAttribute('data-exercise-id') || null,
        renderHTML: attributes => attributes.exerciseId ? { 'data-exercise-id': attributes.exerciseId } : {},
      }
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="open-questions-exercise"]',
      },
    ];
  },
  
  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'open-questions-exercise' })];
  },
  
  addNodeView() {
    return ReactNodeViewRenderer(OpenQuestionsEmbed);
  },
  
  addCommands() {
    return {
      insertOpenQuestionsExercise:
        (attributes) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: attributes,
          });
        },
    };
  },
}); 